import React, { Component } from 'react';
import { Col, Row, Input, Button, Modal, ModalHeader, ModalBody, FormGroup, Form, Badge } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { BlankCard } from '../../../Base/Common/CommonUIComponents';
import { getAPI } from '../../../Base/API';
import { handleNotification } from '../../../Base/Notification';
import moment from 'moment';

class PciBookingPayCardDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            block: false,
            payCardData: {}
        };
    }

    componentDidMount() {
        if (this.props.token) {
            this.getCardDetails(this.props.token);
        }
    }

    getCardDetails = (token) => {
        this.setState({ block: true }, _ => {
            getAPI(result => {
                const { data, error } = result;

                if (error) {
                    var errorMessage = [];
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        return;
                    }

                    this.setState({ payCardData: (data.response?.[0] ?? {}), block: false });
                }
                else this.setState({ block: false });
            }, `/api/hotel/PCIBooking/v1/paycard/meta/${token}`);
        })
    }

    render() {
        const { block, error, property, payCardData } = this.state;
        const { modal, toggleModal } = this.props;

        return (
            <Modal isOpen={modal} toggle={toggleModal} fade={false} className="modal-lg " >
                <ModalHeader toggle={toggleModal}  >
                    Pay Card Details
                </ModalHeader>
                <ModalBody className="modal-lg p-0">
                    <BlankCard block={block} error={error}>
                        <FormGroup row className="mb-4">
                            <Col sm={4}>
                                <div className="text-muted">Create Date </div>
                                {payCardData.createDate ? moment(payCardData.createDate).format("YYYY-MM-DD HH:mm") : '-'}
                            </Col>
                            <Col sm={8}>
                                <div className="text-muted">userID </div>
                                {payCardData.userID || '-'}
                            </Col>
                        </FormGroup>

                        <FormGroup row className="mb-4">
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Owner Name </div>
                                {payCardData.ownerName || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Owner ID </div>
                                {payCardData.ownerID || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Card Type </div>
                                {payCardData.cardType || '-'}
                            </Col>

                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Leading Digits </div>
                                {payCardData.leadingDigits || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Last Digits </div>
                                {payCardData.lastDigits || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">CVV Exists </div>
                                {payCardData.cvvExists ?? '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Expiration Year </div>
                                {payCardData.expirationYear || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Expiration Month </div>
                                {payCardData.expirationMonth || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">End Retention Date </div>
                                {payCardData.endRetentionDate ? moment(payCardData.endRetentionDate).format("YYYY-MM-DD HH:mm") : '-'}
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Issue Number </div>
                                {payCardData.issueNumber || '-'}
                            </Col>
                            <Col sm={8} className="mb-2">
                                <div className="text-muted">uri </div>
                                {payCardData.uri || '-'}
                            </Col>
                        </FormGroup>
                        <hr />
                        <FormGroup row>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Associated Merchants </div>
                                {payCardData.associatedMerchants ?
                                    payCardData.associatedMerchants.map((el, idx) => 
                                        <div key={idx}>{el}</div>
                                    )
                                : '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Associated Properties </div>
                                {payCardData.associatedProperties ?
                                    payCardData.associatedProperties.map((el, idx) =>
                                        <div key={idx}>{el}</div>
                                    )
                                    : '-'}
                            </Col>

                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Network Token ID </div>
                                {payCardData.networkTokenId || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Network Token Scheme </div>
                                {payCardData.networkTokenScheme || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">Token Location </div>
                                {payCardData.tokenLocation || '-'}
                            </Col>
                            <Col sm={4} className="mb-2">
                                <div className="text-muted">ThreeDSecure Info </div>
                                {payCardData.threeDSecureInfo || '-'}
                            </Col>
                        </FormGroup>
                    </BlankCard>
                </ModalBody>
            </Modal>
        );
    }
}

export default injectIntl(PciBookingPayCardDetails);
